import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { SEO } from '../components/seo/index.js';
import { AdminSidebar } from '../components/admin/AdminSidebar.js';
import { AdminTopBar } from '../components/admin/AdminTopBar.js';

export function AdminLayout() {
  const { t } = useTranslation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  useEffect(() => {
    const stored = window.localStorage.getItem('ig-admin-sidebar-collapsed');
    if (stored === '1') {
      setSidebarCollapsed(true);
    }
  }, []);

  useEffect(() => {
    window.localStorage.setItem('ig-admin-sidebar-collapsed', sidebarCollapsed ? '1' : '0');
  }, [sidebarCollapsed]);

  return (
    <div className="min-h-screen bg-ig-bg-primary text-ig-text-primary">
      <SEO noindex title={t('admin.pageTitle', { defaultValue: 'Admin' })} description="Private InterviewGator admin area." />
      <div className="flex min-h-screen">
        <AdminSidebar
          collapsed={sidebarCollapsed}
          mobileOpen={mobileSidebarOpen}
          onCloseMobile={() => setMobileSidebarOpen(false)}
          onToggleCollapsed={() => setSidebarCollapsed((value) => !value)}
        />
        <div className="flex min-h-screen min-w-0 flex-1 flex-col">
          <AdminTopBar onToggleSidebar={() => setMobileSidebarOpen((value) => !value)} />
          <main className="min-h-0 flex-1 overflow-y-auto p-4 lg:p-8">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
